import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import ActivePage from "../../../partials/active-page";
import SubPartialDetailView from "./subDetail";
import {
	GET_RENEWAL,
	RENEW_SERVICE
} from "../../../queries/subscription.query";
import AlertMessage from "../../../partials/alertMessage";
import LoadingSpinner from "../../../partials/loading";
import { useQuery, useMutation } from "@apollo/react-hooks";
import RenewalList from "./RenewalList";
import Pagination from "../../../partials/pagination";
import RenewForm from "./RenewForm";
import auth from "../../../providers/Auth.Provider";
import { Redirect } from "react-router-dom";

const SubscriptionDetail = ({ match, history, location }) => {
	const [renew, SetRenew] = useState(false);
	const { id } = match.params;
	const { state } = location;
	const [
		RenewFunc,
		{ loading: rLoading, data: rData, error: rError }
	] = useMutation(RENEW_SERVICE, {
		update(
			caches,
			{
				data: { RenewSubscription }
			}
		) {
			const { GetServiceRenewalList } = caches.readQuery({
				query: GET_RENEWAL,
				variables: { id }
			});
			GetServiceRenewalList.docs.unshift(RenewSubscription.doc);
			// Update
			caches.writeQuery({
				query: GET_RENEWAL,
				variables: { id },
				data: { GetServiceRenewalList }
			});
		}
	});
	const title = "Subscription Detail";
	const pages = [
		{
			title: "Management",
			path: "/home/app-management"
		},
		{
			title: "Service Subscription",
			path: "/home/app-management/service-sub"
		},
		{ title, path: match.path }
	];
	// query
	const { loading, data, error } = useQuery(GET_RENEWAL, { variables: { id } });

	if (!id || !state)
		history.push({
			pathname: "/home/app-management/service-sub"
		});

	const { LogOut, IsAuthenticationError } = auth.authProvider;
	if (
		(error && IsAuthenticationError(error.message)) ||
		(rError && IsAuthenticationError(rError.message))
	) {
		LogOut();
		return (
			<Redirect
				to={{
					pathname: "/login",
					search: `?redirect=${location.pathname}`
				}}
			/>
		);
	}
	return (
		<>
			<Helmet>
				<title>
					{title} | {appName}
				</title>
			</Helmet>
			<ActivePage pages={pages} title={title} />
			<div className="row">
				<div className="col-md-4">
					<div className="card">
						<div className="card-head">
							<header>
								<button
									onClick={() => history.goBack()}
									className="mdl-button mdl-button--icon margin-right-5"
								>
									<i className="material-icons">arrow_back_ios</i>
								</button>
								Subscription Detail
							</header>
						</div>
						<div className="card-body">
							{state && <SubPartialDetailView item={state.item} />}
						</div>
					</div>
				</div>
				<div className="col-md-8">
					{renew && (
						<div className="card fade-in">
							<div className="card-head">
								<header>New Service Renewal Form</header>
							</div>
							<div className="card-body">
								<LoadingSpinner loading={rLoading} />
								<AlertMessage
									message={rError && rError.message}
									failed={true}
								/>

								<RenewForm
									onCancel={() => SetRenew(!renew)}
									onSubmit={async item => {
										await RenewFunc({
											variables: { id, model: { id, ...item } }
										});
										SetRenew(false);
									}}
								/>
							</div>
						</div>
					)}
					<div className="card">
						<div className="card-head">
							<header>Subscription Renewal Detail</header>
							<div className="tools">
								<button
									title="Renew Service"
									onClick={() => {
										SetRenew(!renew);
										document.body.scrollTop = 0;
										document.documentElement.scrollTop = 0;
									}}
									className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10  btn-circle btn-success"
								>
									<i className="material-icons">add</i> Renew Service
								</button>
							</div>
						</div>
						<div className="card-body">
							<LoadingSpinner loading={loading} />
							<AlertMessage message={error && error.message} failed={true} />
							<AlertMessage
								message={rData && rData.RenewSubscription.message}
							/>
							<RenewalList
								currency={state.item.currency}
								items={data && data.GetServiceRenewalList.docs}
							/>
						</div>
						{data && (
							<Pagination
								{...data.GetServiceRenewalList}
								length={data.GetServiceRenewalList.docs.length}
							/>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default SubscriptionDetail;
